export function scrollToElement(el?: HTMLDivElement | null, shiftHeight?: number) {
    if (!el) {
        return;
    }
    const { top } = el.getBoundingClientRect();
    const topShift = shiftHeight ? shiftHeight : 0;
    window.scrollTo({ top: window.scrollY + top - topShift, behavior: 'smooth' });
}
